import "../../assets/ActionList.css";
import { jsx as a } from "react/jsx-runtime";
import { c } from "../../index-LULxUVKG.js";
import { forwardRef as A, isValidElement as l, cloneElement as m, Children as v } from "react";
import { CTAButton as d } from "../CTAButton/CTAButton.js";
import { CTALink as h } from "../CTALink/CTALink.js";
const w = "_actionListItem_wf29n_3", y = "_cta_wf29n_8", C = "_inverted_wf29n_35", L = "_rightSlot_wf29n_103", e = {
  actionListItem: w,
  cta: y,
  inverted: C,
  rightSlot: L
}, W = ({ children: t, inverted: o, ...n }) => t ? !Array.isArray(t) && // because we passing props to the copied children TS want us to make sure copied component accept this props
l(t) ? m(t, {
  fullWidth: !0,
  inverted: o
}) : /* @__PURE__ */ a("ul", { ...n, children: v.map(
  t,
  (r, i) => l(r) ? /* @__PURE__ */ a(
    "li",
    {
      className: c(e.actionListItem, {
        [e.inverted]: o
      }),
      children: m(r, {
        fullWidth: !0,
        inverted: o
      })
    },
    `action-item-${i}`
  ) : null
) }) : null, j = A(
  ({
    children: t,
    fullWidth: o = !1,
    href: n,
    inverted: r = !1,
    iconLeft: i,
    iconRight: s,
    testID: f,
    className: p,
    ...u
  }, _) => /* @__PURE__ */ a(
    n !== void 0 ? h : d,
    {
      style: {
        // if we use custom slot or non-chevron icon add top shift
        "--el-top-offset": s === "chevron-right-small" ? "0" : "-2px"
      },
      className: c(
        e.cta,
        { [e.inverted]: r },
        p
      ),
      fullWidth: o,
      href: n,
      iconLeft: i,
      iconRight: !s && !i ? "chevron-right-small" : s,
      ref: _,
      testID: f,
      variant: "primary",
      ...u,
      children: t
    }
  )
);
export {
  j as Action,
  W as ActionList
};
